import { cloneDeep } from 'lodash';

const categoriesIds = {
  SAGAH         : 1,
  FORUM         : 2,
  TEST          : 3,
  COURSEWORK    : 4,
  WEBCONFERENCE : 5
};

const bookDetailTypes = {
  ACTIVITY      : 'a',
  PARTICIPATION : 'p'
};

const formulaTypes = {
  AVERAGE : 'average',
  FINAL   : 'final',
  RESULT  : 'result'
};

const resultTypes = {
  APPROVED    : 1,
  DISAPPROVED : 2,
  EXAM        : 3,
  IN_PROGRESS : 4
};

const blockManagement = {
  gradeTypes: {
    INFORMED   : 'informed',
    CALCULATED : 'calculated'
  },
  variablesOrigin: {
    BLOCK : 'blocks',
    ITEMS : 'items'
  },
  buildFormula: {
    AVERAGE : 'average',
    SUM     : 'sum',
    CUSTOM  : 'custom'
  }
};

const gradeTypes = {
  GRADE_FINAL_FORMULA : 1,
  GRADE_CATEGORY      : 2,
  GRADE_BOOK          : 3,
  GRADE_BOOK_DETAIL   : 4
};

const gradeConditionalTypes = {
  PERCENTAGE : 1,
  POINTS     : 2
};

const defaultConfig = {
  locale       : 'pt-BR',
  numberConfig : {
    currency              : 'BRL',
    minimumFractionDigits : 2,
    maximumFractionDigits : 2
  }
};

const formatCurrency = (value, config = defaultConfig) => {
  const formatter = new global.Intl.NumberFormat(
    config.locale,
    config.numberConfig
  );

  return formatter.format(value);
};

const clean = number => {
  if (typeof number === 'number') {
    return number;
  }

  return Number(number.toString().replace(/[^0-9-]/g, ''));
};

const normalizeValue = number => {
  const {
    numberConfig: { maximumFractionDigits }
  } = defaultConfig;
  let safeNumber = number;

  if (typeof safeNumber === 'string') {
    safeNumber = clean(number);

    if (safeNumber % 1 !== 0) {
      safeNumber = safeNumber.toFixed(maximumFractionDigits);
    }
  } else {
    safeNumber = Number.isInteger(number)
      ? Number(number) * 10 ** maximumFractionDigits
      : number.toFixed(maximumFractionDigits);
  }

  return clean(safeNumber) / 10 ** maximumFractionDigits;
};

const numberToCeilEpsilon = number => (number !== null ? Math.ceil(number * 10 + Number.EPSILON) / 10 : 0);

const numberToFormattedDefaultString = (value, defaultNullValue) => {
  const config = cloneDeep(defaultConfig);

  config.numberConfig.roundingMode = 'trunc';

  return value !== null ? formatCurrency(value, config).replace(/[.,]00$/, '') : defaultNullValue;
};

const numberToFormattedString = (value, minFractionDigits= 0, maxFractionDigits= 3) => {
  const config = cloneDeep(defaultConfig);

  config.numberConfig.minimumFractionDigits = minFractionDigits;
  config.numberConfig.maximumFractionDigits = maxFractionDigits;

  return value !== null ? formatCurrency(value, config).replace(/[.,]00$/, "") : 0;
};

const stringToNumber = value => (value ? parseFloat(value.replace(',', '.')) : 0);

const stringToNumberWithFormatting = value => {
  if (!value || typeof value !== "string") {
    return value || 0;
  }

  const workingValue = !/\d,/.test(value) ? value.replace(',', '') : value;

  const replacedValue = workingValue.replace(',', '.');

  const [integerPart, decimalPart] = replacedValue.split('.');

  const truncatedDecimal = decimalPart ? decimalPart.slice(0, 3) : '';

  const formattedValue = decimalPart ? `${integerPart || '0'}.${truncatedDecimal}` : integerPart || '0';

  return isNaN(parseFloat(formattedValue)) ? 0 : parseFloat(formattedValue);
};

const isValidValue = (value, maxValue = 100) => {
  const parsed = typeof value === 'string' ? stringToNumber(value) : value;
  return parsed >= 0 && parsed <= maxValue;
};

const isNumber = evt => {
  const myEvent = evt || window.event;
  const charCode = myEvent.which ? myEvent.which : myEvent.keyCode;

  if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44) || charCode === 101) {
    myEvent.preventDefault();
  } else {
    return true;
  }
};

const convertGradeToComma = (grade)=> {
  if (grade?.toString().includes('.')) {
    return grade.toString().replace('.', ',');
  }
  return Number(grade);
};

export {
  isNumber,
  isValidValue,
  numberToFormattedString,
  numberToFormattedDefaultString,
  numberToCeilEpsilon,
  stringToNumber,
  normalizeValue,
  formatCurrency,
  categoriesIds,
  bookDetailTypes,
  blockManagement,
  formulaTypes,
  resultTypes,
  gradeTypes,
  gradeConditionalTypes,
  stringToNumberWithFormatting,
  convertGradeToComma
};
